module.exports = __webpack_public_path__ + "img/3d-transform_en.909b878.jpg";